const ORDER_COUNTRIES = [{
  value: 'AT',
  label: 'AT',
}, {
  value: 'CZ',
  label: 'CZ',
}, {
  value: 'DE',
  label: 'DE',
}, {
  value: 'ES',
  label: 'ES',
}, {
  value: 'FR',
  label: 'FR',
}, {
  value: 'HU',
  label: 'HU',
}, {
  value: 'IT',
  label: 'IT',
}, {
  value: 'NL',
  label: 'NL',
}, {
  value: 'PL',
  label: 'PL',
}, {
  value: 'SK',
  label: 'SK',
}];

export default ORDER_COUNTRIES;
